export class PhoneValidator {
    private static countryPrefixes: Map<string, string> = new Map();
    private static isInitialized = false;

    private static phoneLengths: Map<string, number> = new Map([
        ['GT', 8],  // Guatemala
        ['MX', 10], // México
        ['CO', 10], // Colombia
        ['BO', 8],  // Bolivia
    ]);

    static updateCountryPrefixes(countries: any[]): void {
        if (this.isInitialized) {
            console.log('Ya inicializado, saltando actualización');
            return;
        }

        this.countryPrefixes.clear();
        
        countries.forEach(country => {
            const prefix = country.name.split('+')[1].trim();
            this.countryPrefixes.set(country.id, prefix);
            console.log(`Agregando prefijo: ${country.id} -> ${prefix}`);
        });
        
        this.isInitialized = true;
    }

    private static ensureInitialized(): void {
        if (!this.isInitialized || this.countryPrefixes.size === 0) {
            throw new Error('PhoneValidator no ha sido inicializado correctamente');
        }
    }

    static validatePhoneNumber(value: any, countryId = 'GT'): string {
        this.ensureInitialized();
        console.log('Validando número:', { value, countryId });
        
        if (!value) return '';
        
        const phoneValue = typeof value === 'string' ? value : value.toString();
        let cleanNumber = phoneValue.replace(/\D/g, '');
        
        const countryPrefix = this.countryPrefixes.get(countryId);
        
        if (countryPrefix && cleanNumber.startsWith(countryPrefix)) {
            cleanNumber = cleanNumber.substring(countryPrefix.length);
        }

        const expectedLength = this.phoneLengths.get(countryId) || 8;
        cleanNumber = cleanNumber.slice(0, expectedLength);
        
        return cleanNumber;
    }
}
